import { defaultSearchVerticalRoutes } from 'constants/search'
import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import useGlobalSearchVerticals from './useGlobalSearchVerticals'

export default function useCurrentGlobalSearchVerticalPage(): App.SearchVertical | undefined {
  const location = useLocation()
  const searchVerticals = useGlobalSearchVerticals()
  const currentGlobalSearchVerticalPage = useMemo(() => {
    return searchVerticals.find((searchVertical) => {
      const routes = defaultSearchVerticalRoutes.get(searchVertical.vertical)
      return matchLocaleAwarePath(location.pathname, { path: routes })
    })?.vertical
  }, [location.pathname, searchVerticals])

  return currentGlobalSearchVerticalPage
}
